import {FC, FormEvent, useContext, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import Button from 'components/Button';
import {set} from 'date-fns';
import DateSelectContext from '../../context';
import {getMinuteOptions, hourOptions} from '../../utils';

const DateSelectTime: FC = () => {
    const {t} = useTranslation();
    const {disabled, minuteStep, onChange, onHide, value} =
        useContext(DateSelectContext);

    const onSetHours = (event: FormEvent<HTMLSelectElement>) => {
        if (value) {
            onChange(set(value, {hours: Number(event.currentTarget.value)}));
        }
    };

    const onSetMinutes = (event: FormEvent<HTMLSelectElement>) => {
        if (value) {
            onChange(set(value, {minutes: Number(event.currentTarget.value)}));
        }
    };

    const minuteOptions = useMemo(
        () => getMinuteOptions(minuteStep),
        [minuteStep],
    );

    const timeDisabled = disabled || !value;

    return (
        <>
            <div className="text-sm">{t('form:time')}</div>
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <select
                        disabled={timeDisabled}
                        onChange={onSetHours}
                        value={String(value?.getHours() ?? 9)}
                    >
                        {hourOptions.map(({label, value: hour}) => (
                            <option key={hour} value={hour}>
                                {label}
                            </option>
                        ))}
                    </select>
                    <span>:</span>
                    <select
                        disabled={timeDisabled}
                        onChange={onSetMinutes}
                        value={String(value?.getMinutes() ?? 0)}
                    >
                        {minuteOptions.map(({label, value: minute}) => (
                            <option key={minute} value={minute}>
                                {label}
                            </option>
                        ))}
                    </select>
                </div>
                <Button onClick={onHide}>{t('form:ok')}</Button>
            </div>
        </>
    );
};

export default DateSelectTime;
